import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "app/base";
import { environment } from 'environments/environment';
import { PadraoService } from '../../../service/padrao.service';

@Component({
    selector: 'usuario-etapa2',
    templateUrl: './usuario-etapa2.component.html',
})
export class CrudUsuarioEtapa2Component extends BaseStepComponent {
    @Input() unidadesOptions: SelectItem[];
    @Input() usuarioOptions: SelectItem[];
    @Input() historicoPermissoes: any;
    filtro = this.formBuilder.group({
        possui: [null],
        query: [null],
        tipo: [null],
        order: 'desc'
    });

    init() {
        if (sessionStorage.getItem("msg") !== null) {
            super.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem("msg"))
        }
        sessionStorage.removeItem("msg");
    }
}


// WEBPACK FOOTER //
// ./src/app/usuario/crud/etapas/usuario-etapa2.component.ts